import { Card, CardOptions } from "./card";

export class NewsFeatureGrid extends Card {
  constructor(element: HTMLElement, options: CardOptions) {
    super(element, options);
  }
}

export default function newsFeatureGridInit() {
  const newsFeedMainCard = document.querySelectorAll(
    ".news-feature-grid__main-story"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < newsFeedMainCard.length; i++) {
    new NewsFeatureGrid(newsFeedMainCard[i], {
      clickable: true,
      ctaClass: "news-feature-grid__main-story-title a",
    });
  }
  const newsFeedCards = document.querySelectorAll(
    ".news-feature-grid__list-item"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < newsFeedCards.length; i++) {
    new NewsFeatureGrid(newsFeedCards[i], {
      clickable: true,
      ctaClass: "news-feature-grid__list-item-title a",
    });
  }
}
